import type { VideoContentObject } from 'models';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, Modal, message } from 'ui';
import { useCreateAbuseReportMutation } from 'features/report';

export const useReportVideo = ({ videoContentObject }: { videoContentObject: VideoContentObject }) => {
  const { t } = useTranslation();
  const { mutateAsync: reportVideo } = useCreateAbuseReportMutation();
  const [modal, contextHolder] = Modal.useModal();

  const confirm = useCallback(
    () =>
      modal.confirm({
        content: 'We will notify admins of your organization',
        icon: <Icon color="info" icon="flag-1-line" />,
        okText: 'Yes, report',
        async onOk() {
          await reportVideo(
            { contentObjectId: videoContentObject.id },
            {
              onError() {
                message.error('Something went wrong.');
              },
              onSuccess() {
                message.success('Successfully reported.');
              },
            },
          );
        },
        title: t('Are you sure you want to report {{name}}?', { name: videoContentObject.video.name }),
      }),
    [reportVideo, t, videoContentObject.id, videoContentObject.video.name, modal],
  );

  return useMemo(() => ({ confirm, contextHolder }), [confirm, contextHolder]);
};
